<% var component = new Anvil.models.components.SortList(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col-auto pr-0 py-1">
	<ul class="sortlist list-unstyled my-3">
		<% for (let i = 0; i < field.options.length; i++) { %>
		<li value="<%= i %>" class="sortlist-item"><i class="fa fa-xs fa-grip-horizontal mr-2"></i><%= field.options[i] %></li>
		<% } %>
	</ul>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<ul class="sortlist list-unstyled my-3">
			<% for (let i = 0; i < field.options.length; i++) { %>
			<li value="<%= i %>" class="sortlist-item"><i class="fa fa-xs fa-grip-horizontal mr-2"></i><%= field.options[i] %></li>
			<% } %>
		</ul>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
